import { matchSorter } from 'match-sorter';
import { useCallback, useState } from 'react';

import arrow from './assets/lottie-arrow.json';
import brain from './assets/lottie-brain.json';
import business from './assets/lottie-business.json';
import check from './assets/lottie-check.json';
import confetti from './assets/lottie-confetti.json';
import email from './assets/lottie-email.json';
import healthcare from './assets/lottie-healthcare.json';
import heart from './assets/lottie-heart.json';
import instagram from './assets/lottie-instagram.json';
import money from './assets/lottie-money.json';
import phone from './assets/lottie-phone.json';
import question from './assets/lottie-question.json';
import school from './assets/lottie-school.json';
import defaultFromVideoTool from './assets/lottie-select.json';
import team from './assets/lottie-team.json';
import technology from './assets/lottie-technology.json';

const PAGE_SIZE = 50;
export const FILTER_KEYS = ['description', 'title'];

// TODO maybe we can move these files to a S3 or infograph and make an API call if this cause any performance issue
const allLottie = [
  ...defaultFromVideoTool,
  ...money,
  ...arrow,
  ...phone,
  ...heart,
  ...email,
  ...brain,
  ...check,
  ...instagram,
  ...school,
  ...team,
  ...business,
  ...technology,
  ...healthcare,
  ...question,
  ...confetti,
];

export const useGifsSearch = () => {
  const [query, setQuery] = useState<string>('');
  let isLoadingMore = false;

  // keeping this to a possible API call one day
  const nextPage = useCallback(() => {}, []);
  const prevPage = useCallback(() => {}, []);

  const clearSearch = useCallback(() => {
    setQuery('');
  }, []);

  // changing the sorter threshold: matchSorter.rankings.WORD_STARTS_WITH,
  const filteredLottie = matchSorter(allLottie, query, {
    keys: FILTER_KEYS,
  });

  return {
    data: query ? filteredLottie : [],
    error: false,
    isLoadingMore,
    query,
    clearSearch,
    setQuery,
    nextPage,
    prevPage,
    PAGE_SIZE,
  };
};
